import { TasksProvider } from './context/TasksContext';
import { TasksView } from './TasksView';

export const TasksContainer = () => (
  <TasksProvider>
    <TasksView />
  </TasksProvider>
);
